/* ==================================================
 *  Queries
 *  ==================================================*/

var widthWindow = $(window).width();

var mediaQuery = {
  xs: 520,
  sm: 768,
  md: 992,
  lg: 1200
};

function sizeWindow(val) {
  if (val) {
    widthWindow = val;
  } else {
    return widthWindow;
  }
}

function max_xs() {
  return (sizeWindow < (mediaQuery.xs - 1));
}

function min_sm() {
  return (sizeWindow >= mediaQuery.sm);
}

function max_sm() {
  return (sizeWindow < (mediaQuery.md - 1));
}
